const PaymentData = {
  getPaymentData: (paymentId: string) => `/ExternalSale/ticketPrices?paymentIdentifier=${paymentId}`,
};

export default PaymentData;
